import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { Product } from '../types/product.type';

export type PrivateProductPayload = {
  product_id: string;
};
export type PrivateProductResponse = ApiResponse<Product>;

export const privateProduct = async (
  payload: PrivateProductPayload
): Promise<PrivateProductResponse> => {
  const { product_id } = payload;
  const url = `product/${product_id}/private`;

  return await apiClient.patch(url);
};

export function privateProductMutationOptions() {
  return mutationOptions<
    PrivateProductResponse,
    AxiosError,
    PrivateProductPayload
  >({
    mutationFn: privateProduct,
  });
}
